<style scoped>
.settings-tabs{
  --primary-color: #5C7182;
  --sidebar-item-hover-color: #E1F0FF;
}

.settings-tabs >>> .nav-link {
  border: none !important;
  border-bottom: none !important;
}

.settings-tabs >>> .nav-tabs {
  border: none !important;
  border-bottom: none !important;
}

.settings-tabs >>> li a.nav-link {
  color: #5C7182 !important;
}

.settings-tabs >>> li a.nav-link.active {
  color: var(--primary-color) !important;
  font-weight: bold;
  border: none;
}

.settings-tabs >>> li a.nav-link:hover {
  background-color: #ffffff;
}

</style>
<template>
  <b-tabs horizontal class="settings-tabs" v-model="tabIndex">
    <b-tab
      title="Change Password"
      id="tab-change-password"
    >
      <b-card-body>
        <change-password-content/>
      </b-card-body>
    </b-tab>
    <b-tab
      v-if="allowedUser"
      title="Change Profile Picture"
      id="tab-change-profile-picture"
    >
      <b-card-body>
        <change-profile-picture-content/>
      </b-card-body>
    </b-tab>
    <b-tab
      v-if="allowedUser"
      title="Social Media"
      id="tab-social-media"
    >
      <b-card-body>
        <social-media-content/>
      </b-card-body>
    </b-tab>
    <b-tab
      v-if="allowedUser"
      title="Portal Team Members"
      id="tab-team-members"
    >
      <b-card-body>
        <team-members-content/>
      </b-card-body>
    </b-tab>
  </b-tabs>
</template>

<script>

import ChangePasswordContent from '@/components/settings/tabs/change_password/ChangePasswordContent';
import ChangeProfilePictureContent from '@/components/settings/tabs/change_profile_picture/ChangeProfilePictureContent';
import SocialMediaContent from '@/components/settings/tabs/social_media/SocialMediaContent';
import TeamMembersContent from '@/components/settings/tabs/team_members/TeamMembersContent';
import { OWNER } from '@/libs/permissions_list';

export default {
  components: {
    TeamMembersContent,
    SocialMediaContent,
    ChangeProfilePictureContent,
    ChangePasswordContent,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    allowedUser() {
      return this.$permissions.checkPermissions(this.teamMemberTabAllowedPermissions);
    },
  },
  data() {
    return {
      tabIndex: 0,
      teamMemberTabAllowedPermissions: [OWNER],
    };
  },
  watch: {
    index: {
      immediate: true,
      handler(val) {
        this.tabIndex = val;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/tabs/SettingsTabs.vue